export const API_BASE_URL = 'https://sheltered-inlet-15640.herokuapp.com/api';
//export const API_BASE_URL = 'http://localhost:5001/api';
export const AUTH_HEADER = {
    'Authorization': 'E#na1RFaA1@jO!FU'
};